import { FollowStatus } from "@onmo/graphql/legacyGraphql";

export const getNewFollowStatus = (
  followStatus?: FollowStatus,
  param?: { unfollow?: boolean },
): FollowStatus => {
  if (param?.unfollow) {
    if (followStatus === FollowStatus.FollowingAndFollowedBy) {
      return FollowStatus.Following;
    } else {
      return FollowStatus.NoFollow;
    }
  } else {
    if (followStatus === FollowStatus.Following) {
      return FollowStatus.FollowingAndFollowedBy;
    } else {
      return FollowStatus.FollowedBy;
    }
  }
};
